import { getTrackerField } from "lib/ga";
import { NOT_A_PRODUCT_TYPE } from "components/collectFunnel/constants";

function formatCollectionProductsPayload(collectionProducts, deliveryItems) {
  let formattedCollectionProducts = [];
  collectionProducts.map((product) => {
    formattedCollectionProducts = [
      ...formattedCollectionProducts,
      {
        type: product.type,
        brand: product.brand || "",
        murfy_repaired: product.murfyRepaired?.value,
        murfy_bought: product.murfyBought?.value,
        is_broken: product.isBroken?.value,
        problem: product.isBroken?.value ? product.problem : "",
        delivery_item_id:
          deliveryItems &&
          deliveryItems.find((item) => item.product_type == product.type) &&
          deliveryItems.find((item) => item.product_type == product.type).id,
      },
    ];
    // removed delivery item from list once it is passed in products list
    // to handle multiple items with same product_type
    if (deliveryItems && deliveryItems.find((item) => item.product_type == product.type)) {
      deliveryItems = deliveryItems.filter(
        (item) => item.id !== deliveryItems.find((item) => item.product_type == product.type).id
      );
    }
  });
  return formattedCollectionProducts;
}

export const formatCollectData = (state) => {
  return {
    customer: {
      email: state.email,
      first_name: state.firstname,
      last_name: state.lastname,
      phone: state.phone,
    },
    address: {
      city:
        state.city ||
        state.address.address_components.find((component) => component.types.includes("locality"))?.long_name,
      extra_information: state.informations || state.addressDetails,
      postal_code: state.postalCode,
      street_number: state.address.address_components?.find((component) => component.types.includes("street_number"))
        ?.long_name,
      street: state.address.address_components?.find((component) => component.types.includes("route"))?.long_name,
      floor: state.floor,
    },
    delivery: {
      elevator: state.elevator === "true" ? true : false,
      difficulties: state.difficulties,
      time_span_beginning: state.timeslot.beginning,
      time_span_end: state.timeslot.end,
      shipping_provider_id: state.timeslot.shipping_provider_id,
    },
    products: state.products
      ? formatCollectionProductsPayload(
          state.products?.filter((product) => product.type !== NOT_A_PRODUCT_TYPE),
          state.deliveryItems
        )
      : [],
    timeslot_id: 0,
    has_opted_in: state.hasOptedIn || false,
    ga_client_id: getTrackerField(),
  };
};
